// Vuetify 3.x imports
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { mdi, aliases, mdi as mdiSvg } from 'vuetify/iconsets/mdi-svg';

// Styles
import 'vuetify/styles';

export default createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
      mdiSvg,
    },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#536DFE',
          secondary: '#59B382',
          accent: '#000000',
          error: '#D0463E',
          darkblue: '#05172e',
        },
      },
      dark: {
        dark: true,
        colors: {
          primary: '#0D47A1',
          secondary: '#59B382',
          accent: '#FFFFFF',
        },
      },
    },
  },
});
